// extracted by mini-css-extract-plugin
export default {"wrapper":"Category_wrapper__p4vLk","active":"Category_active__an5we","label":"Category_label__QF++8","disabled":"Category_disabled__fBByj"};